<div class="w-full relative min-h-75">
    <!-- Dashboard Header -->
    <div class="flex items-center justify-between mb-4">
        <h1 class="text-lg font-bold text-slate-800 dark:text-white">Dashboard Overview</h1>
        <button @click="fetchDashboardData"
            class="px-3 py-1.5 text-xs font-medium rounded bg-indigo-600 hover:bg-indigo-500 text-white cursor-pointer transition-colors">
            <i class="pi pi-refresh mr-1"></i> Refresh
        </button>
    </div>

    <!-- FLEXBOX SEQUENCE CONTAINER -->
    <div class="flex flex-wrap gap-4 w-full items-stretch">
        <div v-for="widget in parsedWidgets" :key="widget.key" :class="getFlexStyle(widget.size)">
            <StatWidget v-if="widget.type === 'stat'" 
                :title  = "widget.title" 
                :value  = "widget.value"
                :format = "widget.format" 
                :icon   = "widget.icon" 
            />

            <ChartWidget v-else-if="widget.type === 'chart'" 
                :title  = "widget.title" 
                :value  = "widget.value" 
            />

            <!-- <DynamicFormLayout

            /> -->

        </div>
    </div>
</div>

<div v-if="formConfigJson && formConfigJson.layout" class="flex flex-wrap -mx-2">
    <!-- Pindahkan getSectionWidthStyle & px-2 ke pembungkus v-for -->
    <div 
        v-for="(section, idx) in formConfigJson.layout" 
        :key="'sec-'+idx"
        :style="getSectionWidthStyle(section)" 
        class="px-2 mb-4"
    >
        <div v-if="section">
            
            <!-- 2. STYLE: GRID -->
            <div v-if="section.style === 'grid'" class="w-full rounded-sm shadow-md border border-slate-200 dark:border-slate-800 p-3 bg-white dark:bg-slate-800 flex flex-col h-125 relative">
                <h2 v-if="section.isdashboard" class="text-md font-semibold tracking-widest text-slate-700 dark:text-slate-200 pb-2 mb-3 border-b border-slate-200 dark:border-slate-700">
                    {{ section.title }}
                </h2>
                <div v-if="isLoading" class="absolute inset-0 z-50 flex items-center justify-center bg-white/50 dark:bg-slate-900/50">
                    <Vue3Lottie :animationData="lottieLoading" height="30vh" width="30vw" />
                </div>
                <div class="w-full grow overflow-hidden" :class="{ 'blur-xs pointer-events-none opacity-50': isLoading }">
                    <ag-grid-vue
                            class                       = "w-full h-full"
                            :columnDefs                 = "columnDefs"
                            :rowData                    = "rowData"
                            :defaultColDef              = "defaultColDef"
                            :theme                      = "AgGridDark"
                            :pagination                 = "true"
                            :paginationPageSize         = "paginationPageSize"
                            :paginationPageSizeSelector = "paginationPageSizeSelector"
                            :animateRows                = "true"
                            @row-double-clicked         = "onRowDoubleClicked"
                    />
                </div>
            </div>

        </div>
    </div>
</div>

<DetailModal v-if   = "isModalOpen" 
    :isOpen         = "isModalOpen"
    :formConfig     = "formConfigJson.layout"
    :rowData        = "selectedRowDetails" 
    :hiddenFields   = "hiddenFields"
    :columnsCustom  = "customColumns"
    :formatsCustom  = "customFormats"
    @close          = "closeModal" 
    @save           = "onRowSaved" 
/>